var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-2 bg-white border rounded" }, [
    _c(
      "div",
      { staticClass: "alert alert-warning pt-4 mb-0" },
      [
        _c("p", [
          _c("strong", { staticClass: "gap-10px d-flex" }, [
            _c("i", { staticClass: "lh-inherit far fa-info-circle" }),
            _vm._v(" " + _vm._s("Some files did have issues")),
          ]),
        ]),
        _vm._v(" "),
        _vm._l(_vm.currentJob.apiJob?.warnings, function (warning) {
          return _c("p", [
            _vm._v(
              _vm._s(_vm._f("trans")(_vm.getTranslatedError(warning.code)))
            ),
          ])
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }